import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { QuoteSectionTommy } from "./components/quote_tommy";
import { History } from "./components/history";
import { Book } from "./components/book";
import { Gallery } from "./components/gallery";
import { Events } from "./components/events";
import { Family } from "./components/family";
import { Press } from "./components/press";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <QuoteSectionTommy />
      <History data={landingPageData.History} />
      <Book data={landingPageData.Book} />
      <Gallery data={landingPageData.Gallery} />
      <Events data={landingPageData.Events} />
      <Family data={landingPageData.Family} />
      <Press data={landingPageData.Press} />
      <Contact data={landingPageData.Contact} />
      <div id="footer">
        <div className="container text-center">
          <p>&copy; 2025 Familie Haas. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </div>
  );
};

export default App;
